// Helpers for custom-form PDF reports (POST mpi_reports/).
// A vehicle has one current report per (custom_form_id, report_type); the
// vehicle embed lists them newest first.

export const findMpiReport = (mpi_reports, customFormId, reportType) => {
  if (!customFormId) return null;
  return (mpi_reports || []).find(r => String(r.custom_form_id) === String(customFormId)
    && (!reportType || !r.report_type || r.report_type === reportType)) || null;
};

// Mirrors the API's stored filename: <displayName>_<stock>_<YYYY-MM-DD>.pdf
export const reportDownloadName = (displayName, vehicle = {}) => {
  const name = (displayName || 'Report').replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  const stock = vehicle.stock || vehicle.vin || 'Report';
  return `${name}_${stock}_${new Date().toISOString().slice(0, 10)}.pdf`;
};

export const formatReportTimestamp = (value) => {
  if (!value) return null;
  return new Date(value).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
